import React from 'react';
import { FormField } from '../../components/FormField';

interface LandCriteriaProps {
  formData: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const LandCriteria: React.FC<LandCriteriaProps> = ({
  formData,
  handleInputChange,
}) => {
  const criteria = [
    { name: 'hasPrivateAccess', label: 'Accès privé' },
    { name: 'hasHeavyVehicleAccess', label: 'Accessibilité pour véhicules lourds' },
    { name: 'hasBuildingPermit', label: 'Permis de construire' },
    { name: 'hasFencing', label: 'Présence de clôtures' },
    { name: 'hasSchoolsNearby', label: 'Proximité d\'écoles et d\'universités' },
    { name: 'hasShopsNearby', label: 'Proximité des commerces' },
    { name: 'hasMainRoadsNearby', label: 'Proximité des routes principales' },
    { name: 'isEnclosed', label: 'Terrain clos ou délimité' },
    { name: 'isBuildable', label: 'Terrain constructible' },
    { name: 'isSloped', label: 'Terrain en pente' },
    { name: 'isFlat', label: 'Terrain plat' },
    { name: 'hasUtilities', label: 'Terrains viabilisés (eau, électricité, gaz, téléphone)' },
    { name: 'hasClearView', label: 'Vue dégagée' },
    { name: 'hasSeaView', label: 'Vue mer' },
  ];

  return (
    <FormField label="Critères du terrain">
      <div className="grid grid-cols-2 gap-4">
        {criteria.map(({ name, label }) => (
          <label key={name} className="flex items-center gap-2">
            <input
              type="checkbox"
              name={name}
              checked={formData[name] || false}
              onChange={handleInputChange}
            />
            <span>{label}</span>
          </label>
        ))}
      </div>
    </FormField>
  );
};